import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DOMAIN_CONFIG } from 'domain-config';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const hostName= window.location.hostname;
    const port = window.location.port
    let cognitoConfig;
    if(port && port.length>0){
      cognitoConfig = DOMAIN_CONFIG[hostName+":"+port]?.tenantId;
    } else{
      cognitoConfig = DOMAIN_CONFIG[hostName]?.tenantId;
    }
    console.log(cognitoConfig);
    
    if (cognitoConfig) {
      console.log(cognitoConfig);
      const clonedRequest = request.clone({
        setHeaders: {
          'X-Tenant-ID': cognitoConfig,
          'X-ORG-ID': cognitoConfig
        }
      });

      return next.handle(clonedRequest);
    }

    return next.handle(request);
  }
}
